import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Optimizechicago() {
  return (
    <section className="leading_miami paving-washington tekrevol_dark_bg">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Tekrevol Is Paving The Digital Way By Creating Next-Gen Mobile
              Apps
            </h2>
            <p>
              We have listed numerous reasons why you should choose Tekrevol as
              your Washington DC app developer. Still, one of the most
              revolutionary aspects of choosing Tekrevol for your project is
              that we are industry leaders. We have solidified our legacy by
              creating some of the best mobile applications for brands over the
              years. We have worked with the medical, travel, healthcare,
              educational, and fitness industries. Our accelerated mobile app
              development is highly robust, innovative, scalable, and quick. We
              are highly focused on efficiency and quality-oriented app
              development, which also defines us as the best app developers in
              DC. Leveraging the latest and emerging technologies, we ensure the
              creation of a mobile application that is future proof and superior
              in every way.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center"
          >
            <div className="leading_miami_img">
              <StaticImage
                src="../../images/location_new/washington/paving_new.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={415}
                height={705}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimizechicago;
